<script>
import { mapGetters } from "vuex";

export default {
  name: "UploadTracker",
  data() {
    return {
      isExpanded: true,
    };
  },
  computed: {
    ...mapGetters({
      uploadState: "upload/uploadState",
    }),
    progressText() {
      const completedFiles = this.uploadState.files.filter((f) => f.status === "completed").length;
      const totalFiles = this.uploadState.files.length;
      const completedUrls = this.uploadState.urls.filter((u) => u.status === "completed").length;
      const totalUrls = this.uploadState.urls.length;

      return `${completedFiles + completedUrls}/${totalFiles + totalUrls}`;
    },
    allItems() {
      const files = this.uploadState.files.map((file) => ({
        ...file,
        displayName: file.name,
      }));

      const urls = this.uploadState.urls.map((url) => ({
        ...url,
        displayName: url.url,
      }));

      return [...files, ...urls].sort((a, b) => {
        if (a.status === b.status) return 0;

        return a.status === "completed" ? -1 : 1;
      });
    },
  },
  methods: {
    fileIcon(item) {
      let icon = "bi-file-earmark";

      if (item.type) {
        const [fileType] = item.type.split("/");

        if (fileType === "image") {
          icon = "bi-file-earmark-image";
        } else if (fileType === "video") {
          icon = "bi-file-earmark-play";
        } else if (fileType === "audio") {
          icon = "bi-file-earmark-music";
        } else if (fileType === "url") {
          icon = "bi-link";
        }
      }

      return icon;
    },
  },
};
</script>

<template>
  <div class="w-96">
    <div class="collapse collapse-arrow">
      <input type="checkbox" :checked="isExpanded" @change="isExpanded = !isExpanded" />

      <div class="collapse-title flex items-center justify-between">
        <span class="font-medium">{{ $t("common.loading.submitting") }}</span>
        <span class="text-sm">{{ progressText }}</span>
      </div>

      <div class="collapse-content">
        <div class="file-list">
          <div
            v-for="item in allItems"
            :key="item.id"
            class="file-item"
            :class="{ 'file-completed': item.status === 'completed' }"
          >
            <div class="flex flex-col gap-1">
              <div class="flex items-center gap-2">
                <i class="text-base-content/70" :class="fileIcon(item)" />
                <span class="text-sm truncate max-w-[200px]">{{ item.displayName }}</span>
                <div class="flex-none ml-auto flex items-center gap-1">
                  <span v-if="item.status === 'pending' && item.progress > 0" class="text-xs text-primary">
                    {{ item.progress }}%
                  </span>
                  <i v-if="item.status === 'completed'" class="bi-check-circle-fill text-success" />
                  <i v-else-if="item.status === 'failed'" class="bi-x-circle-fill text-error" />
                  <div v-else class="loading loading-spinner loading-xs loading-primary" />
                </div>
              </div>
              <div v-if="item.status === 'pending' && item.progress > 0" class="w-full bg-base-300 rounded-full h-1">
                <div
                  class="bg-primary h-1 rounded-full transition-all duration-300"
                  :style="{ width: `${item.progress}%` }"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.file-list {
  @apply flex flex-col gap-2 max-h-60 overflow-y-auto;
}

.file-item {
  @apply py-0.5;

  &.file-completed {
    @apply opacity-60;
  }
}
</style>
